import axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from "axios";
import eventManager, { EVENT_UNAUTHORIZED } from "./event-manager";

export default class ApiProvider {
  private api: AxiosInstance;
  public constructor(config: any) {
    this.api = axios.create(config);
    this.api.interceptors.request.use((param: AxiosRequestConfig) => ({
      ...param,
      headers: {
        ...param.headers,
        // The administration UI is Arabic-first. ABP uses this header when
        // projecting the localized name and description fields in list DTOs.
        "Accept-Language": "ar",
        Authorization: `Bearer ${localStorage.getItem("KEY_TOKEN")}`,
      },
    }));
  }
  public async request<T>(config: any): Promise<any> {
    let result: any;
    try {
      const response = await this.api.request<any>(config);

      return response.data;
    } catch (error: any) {
      let result = error;

      return error.response?.data;
    }
  }
}
